import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: '' }


export const monthWiseChargebackAction = createAsyncThunk(
    'month-wise-chargeback',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/chargeback/month`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const monthWiseChargebackSlice = createSlice({
    name:'month-wise-chargeback',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(monthWiseChargebackAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(monthWiseChargebackAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(monthWiseChargebackAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const monthWiseChargebackReducer = monthWiseChargebackSlice.reducer